module.exports = __webpack_public_path__ + "media/images/shopify_faq_9-084fb2609066824ac0b5802b90e10b56.png";